import * as XLSX from 'xlsx';

const safeFilePart = (s) =>
  String(s || 'export').replace(/[^a-z0-9]+/gi, '_').replace(/^_+|_+$/g, '').slice(0, 60) || 'export';

// rows: array of plain objects (keys become column headers)
export function exportRowsToExcel(rows, { sheetName = 'Sheet1', fileBase = 'export' } = {}) {
  const ws = XLSX.utils.json_to_sheet(rows);
  const headers = rows.length ? Object.keys(rows[0]) : [];
  ws['!cols'] = headers.map(h => ({
    wch: Math.min(60, Math.max(h.length, ...rows.map(r => String(r[h] ?? '').length)) + 2),
  }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${safeFilePart(fileBase)}_${date}.xlsx`);
}
